import { api } from "@/lib/api";

export const shopApi = {
  config: () => api.get("/shop/config").then((r) => r.data),
  collections: () => api.get("/shop/collections").then((r) => r.data),
  products: (params = {}) => api.get("/shop/products", { params }).then((r) => r.data),
  product: (handle) => api.get(`/shop/product/${handle}`).then((r) => r.data),
  cartCreate: (lines) => api.post("/shop/cart", { lines }).then((r) => r.data),
  cartAdd: (cart_id, lines) => api.post("/shop/cart/add", { cart_id, lines }).then((r) => r.data),
  cartUpdate: (cart_id, line_id, quantity) => api.post("/shop/cart/update", { cart_id, line_id, quantity }).then((r) => r.data),
  cartGet: (cartId) => api.get(`/shop/cart/${encodeURIComponent(cartId)}`).then((r) => r.data),
  cartTrack: (payload) => api.post("/shop/cart/track", payload).then((r) => r.data),
  cartComplete: (cart_id) => api.post("/shop/cart/complete", { cart_id }).then((r) => r.data),
};

export function fmtMoney(money) {
  if (!money || money.amount == null) return "";
  const n = Number(money.amount);
  const cur = money.currency || "USD";
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: cur, minimumFractionDigits: n % 1 === 0 ? 0 : 2 }).format(n);
  } catch {
    return `$${n}`;
  }
}
